import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Modal from "../../atoms/modal";
import { deleteUser, getAllUsers } from "../../../firebase/firebaseutils";
import { Link } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import DeleteModal from "../../atoms/deleteModal";

function createData(name, calories, fat, carbs, protein, item) {
  return { name, calories, fat, carbs, protein, item };
}

// const rows = [
//   createData(
//     "Cupcake",
//     305,
//     3.7,
//     67,
//     3.9,
// <div>
//   <IconButton aria-label="delete">
//     <DeleteIcon />
//   </IconButton>
//   <IconButton aria-label="delete">
//     <ArrowForwardIcon />
//   </IconButton>
// </div>
//   ),
//   createData(
//     "Gingerbread",
//     356,
//     16.0,
//     49,
//     3.9,
//     <div>
//       <IconButton aria-label="delete">
//         <DeleteIcon />
//       </IconButton>
//       <button>View</button>
//     </div>
//   ),
// ];

export default function AdminDashboard() {
  // const res = React.useContext(AppContext);
  let [showModal, setShowModal] = React.useState(false);
  let [deleted, setDeleted] = React.useState(false);
  let [userIdToBeDeleted, setUserIdToBeDeleted] = React.useState(false);

  let [rows, setRows] = React.useState([]);
  // let setLoading = res?.appLoadingStates?.setappLoader;

  React.useEffect(() => {
    const users = getAllUsers();
    users.then((users) => {
      setRows([...users]);
    });
    //get all users data
    setDeleted(false);
  }, [deleted]);

  const handleOpenModal = (e) => {
    setUserIdToBeDeleted(e.target.id);
    setShowModal(true);
  };

  return (
    <TableContainer component={Paper} sx={{ width: 1050 }}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Name</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Email</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Status</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Registered As</strong>
            </TableCell>
            {/* <TableCell align="right">
              <strong>Registered As</strong>
            </TableCell> */}
            <TableCell align="right">
              <strong>Actions</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {`${row.firstName + row.lastName}`}
              </TableCell>
              <TableCell align="right">{row.email}</TableCell>
              <TableCell align="right">{row.status}</TableCell>
              <TableCell align="right">
                {row?.registeredInEvent ? row?.registeredInEvent : "Not yet"}
              </TableCell>
              <TableCell align="right">
                <Button
                  aria-label="delete"
                  id={row.uid}
                  onClick={handleOpenModal}
                  variant="text"
                  color="error"
                >
                  DELETE
                </Button>

                <Link
                  to={`/dashboard/user/${row.uid}`}
                  style={{ textDecoration: "none" }}
                >
                  <Button variant="text">View</Button>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <DeleteModal
        message="Are you sure you want to go delete this user?"
        open={showModal}
        setShowModal={setShowModal}
        userIdToBeDeleted={userIdToBeDeleted || ""}
        setDeleted={setDeleted}
      />
    </TableContainer>
  );
}
